import { LoggerUtilService } from './logger-util.service';
import type { LogRecord } from './logger.domain';

export interface Formatter {
  format(record: LogRecord): string;
}

export class JsonFormatter implements Formatter {

  format(record: LogRecord): string {
    const serializedRecord = LoggerUtilService.serializedRecord({
      message: record.message,
      data: record.data,
      tags: record.tags !== undefined && record.tags.length > 0 ? record.tags : undefined });
    return `${record.timestamp} ${record.level} ${record.logger} ${serializedRecord}`;
  }
}
